import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastMessageOptions } from 'primeng/api';

import { VotingResult } from '~/voting/voting.types';

@Component({
  selector: 'app-voting-result-dialog',
  templateUrl: './voting-result-dialog.component.html',
  styleUrls: ['./voting-result-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class VotingResultDialogComponent {
  @Input() visible: boolean;
  @Input() votingResult: VotingResult;

  @Output() visibleChange = new EventEmitter<boolean>();

  public result: VotingResult;
  public messages: ToastMessageOptions[];

  onClose() {
    this.visibleChange.emit(false);
  }
}
